export class SoundFontSynth {
    context;
    synth = null;
    _loadedSoundFont = null;
    get loadedSoundFont() {
        return this._loadedSoundFont;
    }
    get isLoaded() {
        return this._loadedSoundFont !== null;
    }
    sequenceNumber = 0;
    constructor(context) {
        this.context = context;
    }
    async setup() {
        const url = new URL("@ryohey/wavelet/dist/processor.js", import.meta.url);
        await this.context.audioWorklet.addModule(url);
    }
    async loadSoundFont(soundFont) {
        if (this.synth !== null) {
            this.synth.disconnect();
        }
        // create new node
        this.synth = new AudioWorkletNode(this.context, "synth-processor", {
            numberOfInputs: 0,
            outputChannelCount: [2],
        });
        this.synth.connect(this.context.destination);
        this.sequenceNumber = 0;
        this._loadedSoundFont = soundFont;
        for (const e of soundFont.sampleEvents) {
            this.postSynthMessage(e.event, e.transfer);
        }
    }
    postSynthMessage(e, transfer) {
        this.synth?.port.postMessage({ ...e, sequenceNumber: this.sequenceNumber++ }, transfer ?? []);
    }
    sendEvent(event, delayTime = 0) {
        this.postSynthMessage({
            type: "midi",
            midi: event,
            delayTime: delayTime * this.context.sampleRate,
        });
    }
    activate() {
        this.context.resume();
    }
}
//# sourceMappingURL=SoundFontSynth.js.map